import { useGetTabularIngestJobDetailQuery } from '@axilon-apps/domains-ontology-ui-state'
import { Link } from 'react-router-dom'
import { StatusPill } from '../../components/primitives/StatusPill'
import { tabularJobPath } from '../TabularIngestJobPage/route'
import { tabularJobPill } from '../TabularIngestJobPage/tabularJobPill'

/**
 * After *Save as vN* on a draft a held job started, that job re-runs on the
 * new version. This follows it on the job's wake-ups.
 */
export function ResumedRunPill({ jobId }: { jobId: string }) {
  const query = useGetTabularIngestJobDetailQuery(jobId)
  const detail = query.data
  if (!detail) {
    return (
      <div className="text-11 text-ink-3" data-testid="resumed-run">
        re-running job {jobId}…
      </div>
    )
  }
  const pill = tabularJobPill(detail.state, detail.acknowledged, detail.parserKind)
  const rows = detail.tables.reduce((sum, table) => sum + table.rowCount, 0)
  const file = detail.files[0]?.name ?? jobId
  return (
    <div
      className="flex flex-wrap items-center gap-2 rounded-lg border border-line px-3 py-1.5 text-xs"
      data-testid="resumed-run"
    >
      <StatusPill status={pill.status}>{pill.label}</StatusPill>
      <span>
        {detail.state === 'done' ? `re-run complete · ${rows} rows` : `re-running ${file}`}
      </span>
      <Link className="underline" to={tabularJobPath(jobId)}>
        open job
      </Link>
    </div>
  )
}
